import { FETCH_GROUP_SITES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_GROUP_SITES:
			return action.payload;
		default:
			return state;
	}
};
